module.exports = __webpack_public_path__ + "static/beyondblue-75f52d823a5e463c295028a932acac70.png";